// Care Coordination subsection questionnaire constants
export enum CareCoordinationQuestionnaireItem {
  MEDICAL_BACKGROUND_CARE_COORDINATION = 'medical-background/care-coordination',
  MEDICAL_BACKGROUND_CARE_COORDINATION_PREVIOUS_APPOINTMENTS = 'medical-background/care-coordination/previous-appointments',
  MEDICAL_BACKGROUND_CARE_COORDINATION_FUTURE_APPOINTMENTS = 'medical-background/care-coordination/future-appointments',
  MEDICAL_BACKGROUND_CARE_COORDINATION_CARE_TEAM_COORDINATION = 'medical-background/care-coordination/care-team-coordination',
  MEDICAL_BACKGROUND_CARE_COORDINATION_ORDERS_FOR_TREATMENT = 'medical-background/care-coordination/orders-for-treatment',
  MEDICAL_BACKGROUND_CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION = 'medical-background/care-coordination/date-of-verbal-communication'
}
